import { observer } from 'mobx-react';
import { InactivityLogout } from '../../Inactivity';
import IntercomTooling from '../../Tooling/IntercomTooling';
import Footer from '../Footer';
import PlatformRouter from './PlatformRouter';

function PlatformBody() {
  return (
    <>
      <InactivityLogout />
      <PlatformRouter />
      <Footer className="mt-auto text-center" />
      <IntercomTooling />
    </>
  );
}

export default observer(PlatformBody);
